import React, { FC, useState, useContext } from 'react'
import { t } from '@lingui/macro'

import {
  CertificationItemTypes,
  DashboardItemTypes
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { AddItemModal } from '../../dashboards-page/modals/AddItemModal'
import IconMap from '../../../components/common/icon/IconMap'
import IconCalendar from '../../../components/common/icon/IconCalendar'
import { ManageCertificationPageContext } from './ManageCertificationPage'
import { useAddCertificationItemMutation } from './ItemModal.codegen'
import IconDoc from 'front-end/src/components/common/icon/IconDoc'

export const getItemModalTypes = () => ({
  [CertificationItemTypes.topic]: {
    type: DashboardItemTypes.topic,
    icon: <IconDoc size="xl" />,
    label: t`Resource`
  },
  [CertificationItemTypes.pathway]: {
    type: DashboardItemTypes.pathway,
    icon: <IconMap size="medium" />,
    label: t`Pathway`
  },
  [CertificationItemTypes.event]: {
    type: DashboardItemTypes.event,
    icon: <IconCalendar size="medium" />,
    label: t`Event`
  }
})

interface IProps {
  itemIds: number[]
  itemType: CertificationItemTypes
  onSubmit: () => void
}

export const ItemModal: FC<IProps> = ({ itemIds, itemType, onSubmit }) => {
  const { certification } = useContext(ManageCertificationPageContext)
  const [showModal, setShowModal] = useState(false)
  const [addCertificationItem] = useAddCertificationItemMutation()
  const itemModalTypes = getItemModalTypes()
  return (
    <li className="AddNewItem__item page-option">
      <a
        onClick={() => {
          setShowModal(true)
        }}
        className="clickable"
      >
        <span className="AddNewItem__label">
          {itemModalTypes[itemType].icon}
        </span>
        <div className="label">{itemModalTypes[itemType].label}</div>
      </a>

      {showModal && (
        <AddItemModal
          title={itemModalTypes[itemType].label}
          entityType={itemModalTypes[itemType].type}
          itemIds={itemIds}
          onHide={() => setShowModal(false)}
          onSubmit={async (selectedIds) => {
            await addCertificationItem({
              variables: {
                id: certification.id,
                itemIds: selectedIds,
                itemType: itemType
              }
            })
            onSubmit()
          }}
        />
      )}
    </li>
  )
}
